import React from 'react';
import { VersionItem } from '../../atoms/deployment';

interface Version {
  version: string;
  description: string;
  isCurrent: boolean;
}

interface VersionManagementProps {
  versions: Version[];
  onRollback: (version: string) => void;
  onDeploy: (version: string) => void;
}

export const VersionManagement: React.FC<VersionManagementProps> = ({
  versions,
  onRollback,
  onDeploy,
}) => {
  return (
    <div className="space-y-3">
      {versions.map((version) => (
        <VersionItem
          key={version.version}
          version={version.version}
          description={version.description}
          isCurrent={version.isCurrent}
          onAction={() =>
            version.isCurrent ? undefined : onRollback(version.version)
          }
          actionLabel={version.isCurrent ? undefined : 'Rollback'}
        />
      ))}
    </div>
  );
};
